import { useNavigate } from "react-router-dom";
import { toast } from "components/ui/use-toast";
import { CAMPAIGN_MESSAGES } from "../../constants/messages";
import { CampaignType } from "@/@types/campaign-roulette";
import { type UpdateCampaignRouletteFormData } from "../../validations/campaign-roulette.validation";

interface UseFormSubmitProps {
  campaignId: number;
  updateCampaign: (args: { id: number; data: UpdateCampaignRouletteFormData }) => {
    unwrap: () => Promise<unknown>;
  };
  validatePeriod: (args: {
    startDate: string;
    endDate: string;
    excludeId?: number;
    campaignType?: CampaignType;
  }) => {
    unwrap: () => Promise<{ valid: boolean; message: string }>;
  };
}

export const useFormSubmit = ({
  campaignId,
  updateCampaign,
  validatePeriod,
}: UseFormSubmitProps) => {
  const navigate = useNavigate();

  const extractErrorMessage = (error: unknown): string => {
    let errorMessage = CAMPAIGN_MESSAGES.UPDATE.ERROR.description;

    if (
      error &&
      typeof error === "object" &&
      "data" in error &&
      typeof error.data === "object" &&
      error.data
    ) {
      if (
        "messages" in error.data &&
        Array.isArray(error.data.messages) &&
        error.data.messages.length > 0
      ) {
        errorMessage = error.data.messages[0];
      } else if (
        "message" in error.data &&
        typeof error.data.message === "string"
      ) {
        errorMessage = error.data.message;
      }
    }

    return errorMessage;
  };

  const onSubmit = async (data: UpdateCampaignRouletteFormData) => {
    try {
      if (data.startDate && data.endDate) {
        const periodValidation = await validatePeriod({
          startDate: data.startDate,
          endDate: data.endDate,
          excludeId: campaignId,
          campaignType: data.campaignType,
        }).unwrap();

        if (!periodValidation.valid) {
          toast({
            title: "Período indisponível",
            description: periodValidation.message,
            variant: "destructive",
          });
          return;
        }
      }

      const result = updateCampaign({ id: campaignId, data });
      await result.unwrap();
      toast(CAMPAIGN_MESSAGES.UPDATE.SUCCESS);
      navigate("/crm/gestao-campanha-roleta");
    } catch (error: unknown) {
      console.error("❌ Error updating campaign:", error);
      const errorMessage = extractErrorMessage(error);
      toast({
        ...CAMPAIGN_MESSAGES.UPDATE.ERROR,
        description: errorMessage,
      });
    }
  };

  return { onSubmit };
};

